import { useMutation } from "@tanstack/react-query";
import { askAutumn, type AskAutumnResponse } from "../api/crm";

export interface AskAutumnInput {
  messages: Array<{ role: "user" | "assistant"; content: string }>;
  targetCustomerId?: string;
  /** Existing thread to append to. Omit for a new conversation. */
  threadId?: string;
}

/**
 * Client hook for Ask Autumn (admin CRM chat). Wraps the non-streaming
 * batch endpoint. The component passes `threadId` to continue an existing
 * conversation; on a fresh chat, omit it and read `threadId` off the
 * response to continue the thread on subsequent turns.
 */
export function useAskAutumn() {
  return useMutation<AskAutumnResponse, Error, AskAutumnInput>({
    mutationFn: ({ messages, targetCustomerId, threadId }) =>
      askAutumn(messages, { targetCustomerId, threadId }),
  });
}
